export const iconStyle = {
  width: '48px',
  height: '48px',
  textAlign: 'center',
  verticalAlign: 'center',
  display: 'block',
  float: 'left',
  borderRadius: '1px',
  whiteSpace: 'nowrap',
};

export const svgStyle = {
  width: '48px',
  height: '48px',
  display: 'block',
};

export const disabledIconStyle = {
  backgroundColor: 'transparent',
};
